import defined from '~app/core/defined';
import { setPosition } from '~app/core/positionUtils';
import { CANVAS_SIZE, ZOOM_LEVELS, DEFAULT_ZOOM_LEVEL } from './consts';

// Set zoom values
export const setZoom = (state, { zoomLevel, scale, offset_x, offset_y }) => {
  state.zoomLevel = zoomLevel;
  if (state.zoomLevel < 0) state.zoomLevel = 0;
  if (state.zoomLevel >= ZOOM_LEVELS.length)
    state.zoomLevel = ZOOM_LEVELS.length - 1;
  if (!defined(scale)) {
    scale = ZOOM_LEVELS[state.zoomLevel];
  }
  state.scale = scale;
  state.scale = ZOOM_LEVELS[state.zoomLevel];
  state.canZoomIn = state.zoomLevel < ZOOM_LEVELS.length - 1;
  state.canZoomOut = state.zoomLevel > 0;
  if (offset_x !== undefined) state.offset.x = offset_x;
  if (offset_y !== undefined) state.offset.y = offset_y;
};

function updateScroll(state, origScale) {
  const { viewportSize, offset, scale } = state;
  if (origScale !== scale) {
    // recalculate scroll offset so that the center of the visible area doesn't move
    const center_x = (offset.x + viewportSize.x / 2) / origScale;
    const center_y = (offset.y + viewportSize.y / 2) / origScale;
    const x = center_x * scale - viewportSize.x / 2;
    const y = center_y * scale - viewportSize.y / 2;
    state.offset.x = Math.max(0, Math.min(CANVAS_SIZE - viewportSize.x, x));
    state.offset.y = Math.max(0, Math.min(CANVAS_SIZE - viewportSize.y, y));
  }
}

export const zoomToDefault = state => {
  const origScale = state.scale;
  setZoom(state, { zoomLevel: DEFAULT_ZOOM_LEVEL });
  updateScroll(state, origScale);
};

export const zoomIn = state => {
  const origScale = state.scale;
  setZoom(state, { zoomLevel: state.zoomLevel + 1 });
  updateScroll(state, origScale);
};

export const zoomOut = state => {
  const origScale = state.scale;
  setZoom(state, { zoomLevel: state.zoomLevel - 1 });
  updateScroll(state, origScale);
};

export const setSelection = (state, { type, label, from, to, latched }) => {
  state.selection.type = type;
  state.selection.label = label;
  state.selection.from = from;
  state.selection.to = to;
  if (latched !== undefined) state.selection.latched = latched;
};

export const latchForAction = (state, payload) => {
  state.selection.latched = true;
  state.selection.latchData = payload;
};

export const expandLabelBank = state => {
  state.labelBankExpanded = true;
};

export const collapseLabelBank = state => {
  state.labelBankExpanded = false;
};

export const enterComparisonState = state => {
  state.compareWithSolution = true;
};

export const exitComparisonState = state => {
  state.compareWithSolution = false;
};

export const updateCanvasScroll = (state, { x, y }) => {
  state.offset.x = x;
  state.offset.y = y;
};

export const moveInstructionsBox = (state, { x, y, direction, value }) => {
  // Keyboard controlled movement
  if (direction && value) {
    setPosition(state.instructionsBox.position, direction, value);
  }
  // Click and drag
  else {
    state.instructionsBox.position.x = x;
    state.instructionsBox.position.y = y;
  }
};

// remembers the state of showKeyboardShortcuts position
export const moveKeyboardShortcuts = (state, { x, y, direction, value }) => {
  // Keyboard controlled movement
  if (direction && value) {
    setPosition(state.keyboardShortcutsPosition, direction, value);
  }
  // Click and drag
  else {
    state.keyboardShortcutsPosition.x = x;
    state.keyboardShortcutsPosition.y = y;
  }
};

export const expandInstructionsBox = state => {
  state.instructionsBox.expanded = true;
};

export const collapseInstructionsBox = state => {
  state.instructionsBox.expanded = false;
};

// remembers the state of showKeyboardShortcuts
export const showKeyboardShortcuts = state => {
  state.showKeyboardShortcuts = true;
};

export const hideKeyboardShortcuts = state => {
  state.showKeyboardShortcuts = false;
};

export const updateViewportSize = (state, { x, y }) => {
  state.viewportSize.x = x;
  state.viewportSize.y = y;
};

export const setDefaultEditMode = (state, mode) => {
  state.defaultEditMode = mode;
};

export const setDefaultModelType = (state, modelType) => {
  state.defaultModelType = modelType;
};

export const revealHints = state => {
  state.showHints = true;
};

export const hideHints = state => {
  state.showHints = false;
};

export const labelFocusOn = state => {
  state.labelFocus = true;
};

export const labelFocusOff = state => {
  state.labelFocus = false;
};
